/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const RightChat = () => ({
   templateUrl: '/assets/rightChat.html',
   controller: 'ChatCtrl'
})

const ChatWidgetLink = () => ({
   templateUrl: '/assets/chatWidgetLink.html',
   controller: 'ChatCtrl'
})

// @ts-expect-error TS(7006) FIXME: Parameter '$compile' implicitly has an 'any' type.
const ChatWidget = ($compile, $sce, locale) => ({
   replace: true,
   templateUrl: '/assets/chatWidget.html',
   controller: 'ChatCtrl',

   link(s: any, el: any) {
      const chatScope = s.chat
      s.submitButton = el.find('.btn')

      const windowHeight = angular.element(window).height()
      const windowWidth = angular.element(window).width()
      const widgetHeight = el.outerHeight()
      const widgetWidth = el.outerWidth()
      const {
         isRTL
      } = locale.localization

      // reposition chat widget in bottom right corner upon first appearance
      if(windowHeight || windowHeight === 0){
         el.css('top', windowHeight - widgetHeight - 40)
      }
      
      if (isRTL) {
         el.css('left', 60)
      } else if (windowWidth || windowWidth === 0){
      // IE9 and below make the widget *jump* if we don't use the 'left'
      // attr since the draggable directive uses top and left attrs for
      // positioning. Since this is right aligned, we need a silly
      // workaround.
         el.css('left', (windowWidth - widgetWidth - 60))
      }

      return s.$watch('chat.visible', function(visible: any) {
      // remove chat widgets when closing the widget
         if (!visible) {
            return el.find('.springshareWidget, .libraryh3lpWidget, .questionPointWidget').remove()
         } else {
            const chatEl = el.find('.chat')
            // instantiate a new instance of the widget when it is opened
            switch (chatScope.type) {
               case 'libraryh3lp':
                  var chatStyleParam = chatScope.skin ? `skin=${chatScope.skin}` : `css=${chatScope.cssHost}${chatScope.libraryh3lpCssPath}`
                  chatScope.iframeSource = $sce.trustAsResourceUrl(`${chatScope.iframeSource}?${chatStyleParam}`)

                  var libraryh3lp = $compile('<iframe class="libraryh3lpWidget" ng-class="{noOptions:!chat.email}" ng-src="{{chat.iframeSource}}" frameborder="0" title="{{::i18n.translations.CHAT_WITH_LIBRARIAN}}" aria-label="{{::i18n.translations.CHAT_WITH_LIBRARIAN}}"></iframe>')(s)
                  return chatEl.append(libraryh3lp)
               case 'springshare':
                  var springshare = $compile('<div class="springshareWidget" ng-include="\'/assets/springshareWidget.html\'"></div>')(s)
                  return chatEl.append(springshare)
               case 'questionpoint':
                  var questionpoint = $compile('<iframe class="questionPointWidget" src="/widgets/questionPointWidget.html"></iframe>')(s)
                  return chatEl.append(questionpoint)
            }
         }
      })
   }
})

// @ts-expect-error TS(7006) FIXME: Parameter '$compile' implicitly has an 'any' type.
const SpringshareV2 = ($compile, config) => ({
   replace: true,

   link(s: any, el: any) {
      const widgetConfig = config.data.chat.widget
      if (widgetConfig.type === 'springshare_v2') {
         s.widgetConfig = widgetConfig
         const springshare = $compile('<div ng-include="\'/assets/springshareWidgetV2.html\'"></div>')(s)
         return el.replaceWith(springshare)
      }
   }
})

// @ts-expect-error TS(7006) FIXME: Parameter 'i18n' implicitly has an 'any' type.
const WhatsApp = (i18n, menuManager, config) => ({
   replace: true,
   templateUrl: '/assets/whatsappChat.html',

   link(scope: any, el: any, attrs: any) {
      const name = 'whatsappChat' + scope.$id
      const menuConfig = { 
         name,
         type: 'dropdown',
         close: ['any']
      }
  
      menuManager.registerMenu(menuConfig)
      scope.whatsAppHref = `https://api.whatsapp.com/send?phone=${config.data.chat.widget.number}&text=`
      scope.i18n = i18n

      scope.getText = () => encodeURIComponent(scope.message || '')

      scope.click = () => el.find('.dropdown-menu a')[0].click()

      return scope.onToggle = function(status: any) {
         if (status) { menuManager.subMenu[name].openMenu() }
         return el.find("input[type=text]").focus()
      }
   }
})

const EmbeddedWidgetsView = () => ({
   replace: true,
   templateUrl: '/assets/widgets.html',
   controller: 'EmbeddedWidgetsCtrl'
})

const EmbeddedWidgetsBox = function(embeddedWidgetValues: any, $location: any) {
   const locations = {
      'widget-type':'/widgets',
      'search':'/search',
      'customize':'/widgets',
      'code':'/widgets'
   }
   const setFlowLocation = function(btn: 'widget-type' | 'search' | 'customize' | 'code'){
      embeddedWidgetValues.activeTab = btn
      
      if (btn === 'search' && !embeddedWidgetValues.activeWidget) { // if no active widget don't go to search screen
         if($location.path() !== locations['widget-type']) {
            return $location.path(locations['widget-type'])
         } 
      } else if ($location.path() !== locations[btn]) { return $location.path(locations[btn]) }
   }
   return {
      restrict: 'A',
      templateUrl: "/assets/embeddedWidgetsBox.html",
      link(scope: any) {
         scope.embeddedValues = embeddedWidgetValues
         return scope.setFlowLocation = setFlowLocation
      }
   }
}

angular.module('summonApp.directives')
   .directive('chatWidgetLink', ChatWidgetLink)
   .directive('rightChat', RightChat)
   .directive('chatWidget', ['$compile', '$sce', 'localizationService', ChatWidget])
   .directive('springshareV2', ['$compile', 'configService', SpringshareV2])
   .directive('whatsApp', ['translationService', 'menuManagerService', 'configService', WhatsApp])
   .directive('embeddedWidgetsView', EmbeddedWidgetsView)
   .directive('embeddedWidgetsBox', ['embeddedWidgetValues', '$location', EmbeddedWidgetsBox])
